var exports = {
  "CR": "CustomStatusModal.module__modalRoot___QkZTZ0",
  "_l": "CustomStatusModal.module__previewSection___QkZTZ0",
  "uG": "CustomStatusModal.module__statusInputWrapper___QkZTZ0",
  "Dq": "CustomStatusModal.module__characterCount___QkZTZ0",
  "DY": "CustomStatusModal.module__emojiTriggerButton___QkZTZ0",
  "Ow": "CustomStatusModal.module__emojiPreviewImage___QkZTZ0",
  "VK": "CustomStatusModal.module__emojiTriggerButtonActive___QkZTZ0",
  "J7": "CustomStatusModal.module__clearButtonIcon___QkZTZ0",
  "qr": "CustomStatusModal.module__footer___QkZTZ0",
  "x3": "CustomStatusModal.module__expirationSelectWrapper___QkZTZ0",
  "uD": "CustomStatusModal.module__expirationLabel___QkZTZ0",
  "S2": "CustomStatusModal.module__expirationSelect___QkZTZ0",
};

module.exports = exports;
